import * as React from 'react';
import styled from 'styled-components';

import { Box, BoxProps } from '@ovpn-ui/core';

const getSpacingVar = <S extends string>(spacing: S) => `var(--spacing-${spacing}, 32px)` as const;

export const Spacing = {
    md: getSpacingVar('md'),
    sm: getSpacingVar('sm'),
    xs: getSpacingVar('xs'),
    xxs: getSpacingVar('xxs'),
    xxxs: getSpacingVar('xxxs'),
} as const;

const SpacingLayoutInner = styled(Box)<{ $gap: string } & BoxProps<React.ElementType>>`
    gap: ${t => getSpacingVar(t.$gap)};
    align-items: ${t => (t.center ? 'center' : 'normal')};
`;

/**
 * Standart `<Box flex column />` with added `gap` prop.
 *
 * `gap` is using `--spacing-xx` css variables defined in html root.
 */
export function SpacingLayout<E extends React.ElementType = 'div'>({
    gap = 'md',
    column = true,
    children,
    ...rest
}: {
    gap?: keyof typeof Spacing;
    column?: boolean;
    children: React.ReactNode;
} & Omit<BoxProps<E>, 'flex'>) {
    return (
        <SpacingLayoutInner flex column={column} $gap={gap} {...rest}>
            {children}
        </SpacingLayoutInner>
    );
}
